// Языки ИНТЕРФЕЙСА (не языки сбора).
//
// Не путать с вокабуляром локалей (./locale): там `es_MX` — что мы собираем
// в Мексике. Здесь — на каком языке человек читает кабинет. Списки разной
// природы и живут врозь намеренно: закрытие локали не должно отнимать язык
// у проверяющего, а новый язык интерфейса — открывать сбор.
//
// Появился под internal-кабинет (ADR-0069): QA-проверяющих нанимают в
// Испании и ЛатАм, Бразилии, Китае и англоязычных странах. Русский —
// канон и запасной вариант: непереведённая строка показывается по-русски.
import { z } from 'zod';

export const UI_LANGS = ['ru', 'en', 'es', 'pt', 'zh'] as const;
export const UiLangSchema = z.enum(UI_LANGS);
export type UiLang = z.infer<typeof UiLangSchema>;

// Языки, для которых существует перевод. Русский — сам текст-источник.
export const UI_LANGS_TRANSLATED = ['en', 'es', 'pt', 'zh'] as const;
export type UiLangTranslated = (typeof UI_LANGS_TRANSLATED)[number];

// Как язык называется на себе самом — для переключателя.
export const UI_LANG_LABEL = {
  ru: 'Русский',
  en: 'English',
  es: 'Español',
  pt: 'Português',
  zh: '中文',
} as const satisfies Record<UiLang, string>;

// Как язык назвать модели, которая переводит.
export const UI_LANG_NAME_EN = {
  ru: 'Russian',
  en: 'English',
  es: 'Spanish',
  pt: 'Brazilian Portuguese',
  zh: 'Simplified Chinese',
} as const satisfies Record<UiLang, string>;
